module.exports = "/packs/images/homepage/facilities/extreme_tablet~067aa9b655892e5764bba0d5d8bc7bc2.jpg";